import { defineComponent, onBeforeUnmount, watch, } from 'vue';
export const WEFAT_PAGE_THEME_CHANGE_EVENT = 'wefat:page-theme-change';
export const WefatPageMeta = defineComponent({
    name: 'WefatPageMeta',
    props: {
        backgroundColor: { type: String, default: '' },
        backgroundTextStyle: { type: String, default: '' },
        pageStyle: { type: String, default: '' },
    },
    setup(props) {
        let applied = false;
        let initialized = false;
        let previous = [];
        function restore() {
            if (typeof document === 'undefined' || !applied)
                return;
            for (const item of previous) {
                if (item.value.length === 0) {
                    document.documentElement.style.removeProperty(item.name);
                }
                else {
                    document.documentElement.style.setProperty(item.name, item.value, item.priority);
                }
            }
            previous = [];
            applied = false;
        }
        watch([
            () => props.backgroundColor,
            () => props.backgroundTextStyle,
            () => props.pageStyle,
        ], () => {
            if (typeof document === 'undefined')
                return;
            restore();
            const declarations = document.createElement('span').style;
            declarations.cssText = props.pageStyle;
            if (props.backgroundColor.length > 0) {
                declarations.setProperty('background-color', props.backgroundColor);
            }
            previous = [...declarations].map((name) => ({
                name,
                value: document.documentElement.style.getPropertyValue(name),
                priority: document.documentElement.style.getPropertyPriority(name),
            }));
            for (const name of declarations) {
                document.documentElement.style.setProperty(name, declarations.getPropertyValue(name), declarations.getPropertyPriority(name));
            }
            applied = true;
            const theme = props.backgroundTextStyle === 'light'
                ? 'dark'
                : props.backgroundTextStyle === 'dark'
                    ? 'light'
                    : null;
            const variables = Object.freeze([...declarations]
                .filter((name) => name.startsWith('--'))
                .map((name) => Object.freeze({
                name,
                priority: declarations.getPropertyPriority(name),
                value: declarations.getPropertyValue(name),
            })));
            const initial = !initialized;
            document.dispatchEvent(new CustomEvent(WEFAT_PAGE_THEME_CHANGE_EVENT, {
                detail: Object.freeze({
                    backgroundColor: props.backgroundColor,
                    backgroundTextStyle: props.backgroundTextStyle,
                    initial,
                    navigationBackgroundColor: document.documentElement.style
                        .getPropertyValue('--wefat-navigation-background-color').trim(),
                    navigationFrontColor: document.documentElement.style
                        .getPropertyValue('--wefat-navigation-front-color').trim(),
                    theme,
                    variables,
                }),
            }));
            initialized = true;
        }, { immediate: true });
        onBeforeUnmount(restore);
        return () => null;
    },
});
//# sourceMappingURL=page-meta-component.js.map